import React from "react";

export default function App() {
  return (
    <div className="flex items-start justify-center min-h-screen bg-white px-6 pt-16">
      <div className="max-w-lg w-full">
        <div className="flex items-center mb-3">
          <span className="text-red-600 text-2xl mr-2">⚠️</span>
          <h1 className="text-red-600 text-2xl font-semibold">Warning</h1>
        </div>

        <h2 className="text-3xl font-semibold text-gray-900 mb-3">
          Suspected Phishing
        </h2>

        <p className="text-gray-800 mb-2 font-medium">
          This website has been reported for potential phishing.
        </p>
        <p className="text-gray-700 mb-8 leading-relaxed">
          Phishing is when a site attempts to steal sensitive information by
          falsely presenting as a safe source.
        </p>

        <button
          className="bg-gray-900 text-white px-5 py-2 rounded-md hover:bg-gray-800 transition"
          onClick={() => alert("Learn more clicked")}
        >
          Learn More
        </button>
        <div className="border-t border-gray-300 mt-60 mb-6"></div>
        {/* Info text below the line */}
        <div className="text-gray-600 text-sm space-y-1">
          <p>Ray ID: 9900ef1ffb0af767</p>
          <p>Your IP: Domain has reported</p>
          <p>Performance & security got down</p>
        </div>
      </div>
    </div>
  );
}
